import script from "./pc-module-chi-square-analysis-5.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-chi-square-analysis-5.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-chi-square-analysis-5.vue?vue&type=style&index=0&id=7ffde4d8&lang=scss"

const __exports__ = script;

export default __exports__